<template>
  <div class="login">
    <div class="login-container">
      <div class="login-container-bg">
        <div class="login-container-bg1">
          <div @click="onBack" class="login-logo">
            <img class="ll-img" src="../assets/logo1.png" alt="" />
            <div class="ll-text">登录</div>
          </div>
          <el-form class="loginform" ref="form" :rules="rules" :model="form">
            <el-form-item label="监考码" prop="monitorCode">
              <el-input
                @keyup.enter.native="onSubmit('form')"
                placeholder="监考码"
                v-model.trim="form.monitorCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="teacherName">
              <el-input
                @keyup.enter.native="onSubmit('form')"
                placeholder="姓名"
                v-model.trim="form.teacherName"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="teacherCreNumber">
              <el-input
                @keyup.enter.native="onSubmit('form')"
                placeholder="身份证号"
                v-model.trim="form.teacherCreNumber"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              prop="vcode"
              label="验证码"
              style="position: relative;"
            >
              <el-input
                @keyup.enter.native="onSubmit('form')"
                placeholder="验证码"
                v-model="form.vcode"
              >
              </el-input>
              <div class="sendcode">
                <el-button v-if="lastTime <= 0" @click="getVcode" type="text"
                  >发送验证码</el-button
                >
                <el-button v-else class="text-center" type="text"
                  >{{ lastTime }}秒</el-button
                >
              </div>
            </el-form-item> -->
            <el-form-item>
              <el-button
                style="width:100%;height:45px;font-size:18px;margin-top:15px;"
                type="primary"
                @click="onSubmit('form')"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lastTime: 0,
      form: {
        monitorCode: "",
        teacherCreNumber: "",
        teacherName: ""
      },
      rules: {
        monitorCode: [
          { required: true, message: "请输入监考码", trigger: "blur" },
          { min: 8, max: 8, message: '请输入正确的8位监考码', trigger: 'blur' }
        ],
        teacherName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 10, message: '最多允许输入10个字符', trigger: 'blur' }
        ],
        teacherCreNumber: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { min: 1, max: 20, message: '请输入正确的身份证号', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    const userInfo = this.$utils.$localStorage.get("userInfo");
    const AppSource = this.$utils.$localStorage.get("AppSource");
    if (AppSource !== 'live_monitor') {
      window.localStorage.removeItem('collegeId')
      window.localStorage.removeItem('userInfo')
      this.$router.replace("/");
      return
    }
    if (userInfo) {
      this.$router.push("/login-info");
    }
  },
  methods: {
    async getVcode() {
      if (this.form.phone && /^1\d{10}$/.test(this.form.phone)) {
        const codeData = await this.$HTTP.ApiUser.GETsendVcode({
          phone: this.form.phone
        });
        this.$message.success("验证码发送成功！");
        console.log(codeData);
        this.lastTime = 60;
        const intTime = setInterval(() => {
          this.lastTime = this.lastTime - 1;
          if (this.lastTime <= 0) {
            clearInterval(intTime);
          }
        }, 1000);
      } else {
        this.$message.error("请输入合法的手机号");
      }
    },
    onSubmit(formName) {
      this.$refs[formName].validate(async valid => {
        try {
          if (valid) {
            const collegeId = window.localStorage.getItem('collegeId')
            const param = {
              monitorCode: this.form.monitorCode.trim(),
              teacherCreNumber: this.form.teacherCreNumber.trim(),
              teacherName: this.form.teacherName.trim(),
              collegeId: collegeId
            }
            const res = await this.$HTTP.ApiLogin.POSTloginV2(param);
            this.$utils.$localStorage.set("formRequest", param);
            const markTypeArr = []
            if (res.markType) {
              const a = res.markType
              Object.keys(res.markType).forEach(v => {
                markTypeArr.push({title: a[v], markType: Number(v)})
              })
            }
            const markOptions = res.markOptions || []
            const remindOptions = res.remindOptions || []
            const speechOptions = res.audioOptionList || []
            const subjectList = res.subjectList || []
            const isPaperReviewSubject = subjectList.filter(v => v.isPaperReview == 1) || []
            this.$utils.$localStorage.set("isPaperReviewSubject", isPaperReviewSubject);
            this.$utils.$localStorage.set("subjectList", subjectList);
            this.$utils.$localStorage.set("markTypeArr", markTypeArr);
            this.$utils.$localStorage.set("markOptions", markOptions);
            this.$utils.$localStorage.set("remindOptions", remindOptions);
            this.$utils.$localStorage.set("speechOptions", speechOptions);
            this.$utils.$localStorage.set("userInfo", res);
            // V2版本的登录接口不需要一开始登录就开始心跳
            // this.$store.dispatch('startFreshHeartBeat')
            this.$router.push("/login-info");
          } else {
            return false;
          }
        } catch (error) {}
      });
    },
    onBack() {
      window.localStorage.removeItem("collegeId");
      window.localStorage.removeItem("userInfo");
      this.$router.push('/')
    }
  }
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  min-width: 440px;
  display: flex;
  justify-content: center;
  align-items: center;
  &-container {
    width: 440px;
    height: 532px;
    border: 2px solid rgba(112, 112, 112, 0.6);
    border-radius: 16px;
    background-color: rgba(37, 43, 77, 1);
    box-shadow: 0px 14px 32px rgba(0, 8, 29, 0.16);
    &-bg1 {
      width: 100%;
      height: 100%;
      background: url("../assets/img_logo.png") no-repeat bottom right;
      background-size: 60%;
      padding: 30px 50px;
    }
    &-bg {
      width: 100%;
      height: 100%;
      background: url("../assets/img_in.png") no-repeat left top;
      background-size: 100%;
    }
    .login-logo {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      .ll-img {
        width: 32px;
        height: 42px;
      }
      .ll-text {
        width: 48px;
        height: 32px;
        font-size: 24px;
        color: #ffffff;
        position: relative;
        margin-left: 30px;
        &::after {
          position: absolute;
          content: "";
          width: 1px;
          height: 21px;
          top: 50%;
          left: -15px;
          transform: translateY(-50%);
          background: #ccc;
        }
      }
    }
    .loginform {
      width: 340px;
      .sendcode {
        text-align: center;
        width: 102px;
        position: absolute;
        right: 11px;
        bottom: 0px;
        cursor: pointer;
      }

      .sendcode::after {
        content: "";
        position: absolute;
        width: 1px;
        height: 20px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: #d9d9d9;
      }
    }
  }
}
.ac-btn::v-deep .el-button {
  color: #409EFF !important;
  border-color: #409EFF !important;
}
</style>
<style>
.loginform .el-form-item__label {
  color: #fff !important;
}
</style>
